import React from 'react'
import useTranslation from '../hooks/useTranslation'

const Privacy = () => {
  const { t } = useTranslation();

  return (
    <div style={{ paddingTop: '120px' }}>
      <section>
        <div className="container">
          <h2>{t('legal.privacy')}</h2>
          
          <div style={{ marginBottom: '40px' }}>
            <h3>{t('legal.dataProtection')}</h3>
            <p>{t('legal.dataProtectionIntro')}</p>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h3>{t('legal.dataCollection')}</h3>
            <p>{t('legal.dataCollectionText')}</p>
            
            <h4>{t('legal.logData')}</h4>
            <p>{t('legal.logDataText')}</p>
            
            <h4>{t('legal.cookies')}</h4>
            <p>{t('legal.cookiesText')}</p>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h3>{t('legal.thirdParty')}</h3>
            <p>{t('legal.thirdPartyText')}</p>
            
            <h4>SoundCloud</h4>
            <p>{t('legal.soundcloudText')}</p>
            
            <h4>YouTube</h4>
            <p>{t('legal.youtubeText')}</p>
            
            <h4>Instagram</h4>
            <p>{t('legal.instagramText')}</p>
            
            <h4>TikTok</h4>
            <p>{t('legal.tiktokText')}</p>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h3>{t('legal.rights')}</h3>
            <p>{t('legal.rightsText')}</p>
          </div>

          <div style={{ marginBottom: '40px' }}>
            <h3>{t('legal.contact')}</h3>
            <p>{t('legal.contactText')}</p>
            <p>Email: privacy@ayite-dj.com</p>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Privacy
